// extracted by mini-css-extract-plugin
export default {"content":"zKfQ6u","container":"jtpxj1","summary":"WkWd0G","expandIcon":"dIH69Y","mobile":"q7xhoW"};